import React, { useEffect, useState } from 'react';
import {
  AutoComplete, Button, Drawer, Input,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { IconListFilter } from '../../Icon';

import styles from './index.module.scss';
import Filter from '../Filter';
import { Article, useArticlesGet } from '../../../../hooks/api/article';
import { useArticleContext } from '../context';

export default function SearchContent(): React.ReactNode | null {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [searchAutocomplete, setSearchAutoComplete] = useState<Article[]>([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { id, name } = useParams();
  const {
    fetch, setData, setSearch, search, currentProduct,
  } = useArticleContext();

  useEffect(() => {
    if (fetch && search) {
      fetch({ pageSize: '10', title: search, status: 'published' }).then((res) => {
        setSearchAutoComplete(res?.data ?? []);
      });
    }
  }, [search]);

  useEffect(() => {
    if (!searchParams.get('title')) {
      setSearch?.('');
    }
  }, []);

  return (
    <div className={styles.search}>
      <h1>{`Find help by ${name || 'product'}`}</h1>
      <div className={styles.searchItems}>
        <AutoComplete
          options={searchAutocomplete.map((item) => ({ value: item.title }))}
          value={search}
          onChange={(value) => {
            setSearch?.(value);
          }}
          onSearch={(value) => {
            setSearch?.(value);
          }}
          onSelect={(value) => {
            setSearch?.(value);
            // navigate(`/search-results?title=${encodeURIComponent(value)}`);
            if (id) {
              navigate(`/search-results/${id}/${name}?title=${encodeURIComponent(value)}`);
            } else {
              navigate(`/search-results?title=${encodeURIComponent(value)}`);
            }
          }}
        >
          <Input
            prefix={<SearchOutlined />}
            className={styles.inp}
            allowClear
            placeholder="Search"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && search) {
                if (id) {
                  navigate(`/search-results/${id}/${name}?title=${encodeURIComponent(search)}`);
                } else {
                  navigate(`/search-results?title=${encodeURIComponent(search)}`);
                }
              }
            }}
          />
        </AutoComplete>
        <Button
          type="primary"
          className={styles.btn}
          icon={<IconListFilter />}
          onClick={() => setFilterOpen(true)}
        >
          Filter
        </Button>
      </div>
      <Filter open={filterOpen} onClose={() => setFilterOpen(false)} />
    </div>
  );
}
